module.exports = __webpack_public_path__ + "pc/img/work_list8.9b92bf0f.jpg";